import { Grid } from '@theme-ui/components';

import { isNotNullish } from '@app/helpers/predicate';
import { rem } from '@app/styles/theme/layout';

import { LicenseCard } from '../LicenseCard/LicenseCard';
import { LicenseCardVariant } from '../LicenseCard/LicenseCard.constants';
import type { LicenseCardGridProps } from '../LicenseSelector';

const MultiProductGrid = ({
  hasBestOption,
  variantLicenses,
  getCardVariant,
  selectedVariant,
  setSelectedVariant,
}: LicenseCardGridProps) => {
  return (
    <Grid
      sx={{
        gridColumnGap: 2,
        gridTemplateColumns: ['1', '1', 'repeat(2, 1fr)'],
        gridRowGap: [rem(12), rem(12), hasBestOption ? rem(40) : rem(12)],
        pb: hasBestOption && rem(30),
      }}
    >
      {variantLicenses?.map((variant) => {
        if (isNotNullish(variant)) {
          const cardVariant = getCardVariant(variant);

          return (
            <LicenseCard
              variant={cardVariant}
              isSelected={
                variant?.product?.uid === selectedVariant?.product?.uid
              }
              key={variant?.product?.uid}
              productVariant={variant}
              onClick={(e) => {
                e.preventDefault();
                setSelectedVariant(variant);
              }}
              sx={{
                mb: [
                  cardVariant === LicenseCardVariant.Recommendation
                    ? rem(30)
                    : 0,
                  null,
                  0,
                ],
              }}
            />
          );
        }
      })}
    </Grid>
  );
};

export default MultiProductGrid;
